module.exports = __webpack_public_path__ + "media/images/telemedicine-7822cc06f00a0e2f89ba103f3da5e227.png";